import styled from 'styled-components'
import Background from '../layout/Background'
import Container from '../layout/Container'
import Stack from '../layout/Stack'

type DocumentPageHeaderProps = {
  title: string;
  subtitle?: string | null;
  centered?: boolean
}

export default function DocumentPageHeader( {
  title,
  subtitle,
  centered = false, 
} : DocumentPageHeaderProps ) {
  return (
    <Background 
      className="bx-page-document-header"
      $color="grey100"
    >
      <Container>
        <Stack
          $top={ 12 }
          $bottom={ 12 }
        >
          <StyledDocumentPageHeader 
            $centered={ centered }
          >
            <h1>{ title }</h1>
            {subtitle && <h2>{ subtitle }</h2>}
          </StyledDocumentPageHeader>
        </Stack>
      </Container>
    </Background>
  )
}

const StyledDocumentPageHeader = styled.div<{ $centered: boolean }>`
  text-align: ${ p => p.$centered ? 'center' : 'left' };

  h1 {
    margin: 0;
    ${ p => p.theme.typo.semiBold }
    font-size: ${ p => p.theme.typo.sizes.veryLarge };

    @media ( min-width: 500px ) {
      font-size: ${ p => p.theme.typo.sizes.smallHero };
    }

    @media ( min-width: 900px ) {
      font-size: ${ p => p.theme.typo.sizes.hero };
    }
  }

  h2 {
    margin: 0 auto;
    font-size: ${ p => p.theme.typo.sizes.large };
    font-weight: normal;
    max-width: 36rem;

    &:not(:first-child) {
      margin-top: 3rem;
    }
  }
`
